import React, { FC } from 'react'

import { useDispatch } from 'react-redux'

import { addInterestInSearchOptionsAction } from 'actions/mainSearchAction'
import { InterestsView } from 'components/page/ForeignProfile/Field/Interests/InterestsView'
import { GQLForeignRootQuery } from 'components/page/ForeignProfile/gql/__generated__/ForeignRoot'

interface InterestProps {
  data: NonNullable<
    GQLForeignRootQuery['user']
  >['interests']['interests']['nodes']
  dataCurrentUser: NonNullable<
    GQLForeignRootQuery['my']
  >['interests']['interests']['nodes']
  count: number
}

export const Interests: FC<InterestProps> = ({
  data,
  dataCurrentUser,
  count,
}) => {
  const dispatch = useDispatch()

  const handleSaveInterestSearch = (id: number) => {
    dispatch(addInterestInSearchOptionsAction(id))
  }

  return (
    <InterestsView
      data={data}
      dataCurrentUser={dataCurrentUser}
      count={count}
      onSaveInterestSearch={handleSaveInterestSearch}
    />
  )
}
